<template>
    <b-container fluid class="p-3">
        <b-card v-if="composition">

            <b-media right-align no-body >
                <b-media-aside vertical-align="center">
                    <svg v-if="composition.svg" xmlns="http://www.w3.org/2000/svg" :viewBox="composition.viewbox" v-html="composition.svgPart" class="thumbnail"></svg>
                </b-media-aside>

                <b-media-body>
                    <b-badge>{{composition.dimensions}}</b-badge><br/>
                    {{composition.product ? composition.product.name[language] : 'No product'}}<br/>
                    {{composition.thickness ? composition.thickness.thickness : 'No thickness'}} mm<br/>
                    <span :title="composition.createdAtLabel">Créé {{composition.createdAtFromNow}}</span><br/>
                    <t compositions.customercode /> : {{composition.customerPsid}} <span v-if="composition.originalCustomerPsid != composition.customerPsid">( {{composition.originalCustomerPsid}} )</span>
                </b-media-body>
            </b-media>
            <br/>

            <template v-slot:header>
                <a :href="protocol + '//' +editorUrl + '/load/' + composition._id +'?token=' + jwt_token" target="_blank" style="margin-right:1rem">
                    <b class="text-muted">{{composition._id.substring(0,6)}}</b>
                    <small class="text-muted">{{composition._id.substring(6)}}</small>
                </a>
                <div>
                    <b-button-group>
                        <b-button size="sm" variant="info" @click="changeCustomerPsid(composition)" :title="$t('compositions.changecustomercode')"><b-icon icon="file-person"></b-icon></b-button>
                        <b-button size="sm" variant="danger" @click="archive(composition)" title="Archiver"><b-icon icon="trash"></b-icon></b-button>
                    </b-button-group>
                </div>
            </template>

            <template v-slot:footer>
                <small class="text-muted" :title="composition.updatedAtLabel"><t compositions.updatedat /> {{composition.updatedAtFromNow}}</small>
            </template>
            <div id="composition" class="overflow-hidden mx-2">
                <transition name="bounce">
                    <div class="bg-gris-pro rounded-10 px-0 pb-1 mb-2">
                        <div v-for="piece in composition.pieces" v-bind:key="piece.name" class="border-0 rounded-0 bg-transparent px-0 pt-1 mx-1"  :class="{'sizeInvalid' : piece.validSize == false}">
                            <div v-if="piece.isCopyOf == null" class="bg-white rounded-10 d-flex">
                                <div class="d-flex align-items-center col-9 p-0 my-1">
                                    <div v-if="piece.svg" vertical-align="center" v-html="piece.svg" class="thumbnail h-100 bg-gris-pro p-2 ml-1 rounded-10 d-flex align-items-center"></div>
                                    <div class="pl-2 col-10">
                                        <span class="font-weight-bold text-dark text-capitalize">
                                            {{piece.name}}
                                        </span>
                                        <span class="d-flex">
                                            <span class="small font-weight-bold">
                                                <div class="d-flex align-items-center">
                                                    <b-icon icon="crop" font-scale="1" />
                                                    <span v-bind:class="{'text-danger': !piece.validSize}" class="ml-1">{{Math.ceil(piece.width)}} <t addToCart.mm /> x {{Math.ceil(piece.height)}} <t addToCart.mm /></span>
                                                </div>
                                                <div class="d-flex">
                                                    <img :src="require( '@/assets/img/poids.svg')" height="15px">
                                                    <span class="ml-1">{{Math.ceil(piece.weight)}} <t addToCart.kg /></span>
                                                </div>
                                                <b-icon icon="cloud-download" font-scale="1" class="ml-1 cursor-pointer" @click.prevent.stop="exportToDxf(piece.name,composition._id)" />
                                            </span>
                                        </span>
                                    </div>
                                </div>
                                <div class="col-3 p-0 d-flex flex-column justify-content-between">
                                    <div>
                                        <span class="float-right qty text-white font-weight-bold px-2 bg-jaune bg-gris-pro">x {{piece.copies.length + 1}}</span>
                                    </div>
                                    <span class="d-block text-dark font-weight-bold price text-right pr-2 pb-1">{{piece.price ? piece.price.toFixed(2) : "0.00"}} €</span>
                                </div>
                            </div>
                        </div>
                    </div>
                </transition>
            </div>

            <div v-if="importData" class="d-flex justify-content-evenly">
                <div class="importData">
                    <div>Nom du fichier : {{this.importData.filename}}</div>
                    <div :title="composition.createdAtLabel">Créé {{composition.createdAtFromNow}}</div>
                    <b-badge>{{Math.ceil(importData.report.geometry.width)}} x {{Math.ceil(importData.report.geometry.height)}}</b-badge><br/>
                    <div>ImportId : {{this.importData._id}}</div>
                    <div class="d-flex svg-container" @click="visible = !visible; viewer()" v-html="this.importData.report.svg"></div>
                    <div>Nb d'intersection : {{this.importData.report.quickAnalysis.nbIntersections}}</div>
                    <div v-if="this.importData.report.join">Nb de chemin ouvert : {{this.importData.report.join.openpaths}}</div>
                    <b-icon icon="cloud-download" font-scale="1" class="ml-1 cursor-pointer" @click.prevent.stop="exportOrigineDxf()" /><br/>
                </div>

                <div class="importData">
                    <div>Durée de l'import : {{importData.report.import.duration}} ms</div>
                    <div v-if="this.importData.report.join">Durée pour joindre les traits : {{importData.report.join.duration}} ms</div>
                    <div>Mode d'import : {{importData.report.mode}}</div>
                    <div>Mode de quickAnalysis : {{importData.report.quickAnalysis.mode}}</div>
                    <div>Durée de quickAnalysis : {{importData.report.quickAnalysis.duration}} ms</div>
                    <div>Durée du regroupement :  {{importData.report.regroup.duration}} ms</div>
                    <div v-if="this.importData.report.removeFine">Durée de suppresion des traits inutiles :  {{importData.report.removeFine.duration}} ms</div>
                    <div v-if="this.importData.report.reorient">Durée de réorientation :  {{importData.report.reorient.duration}} ms</div>
                </div>
            </div>
        </b-card>
        <transition name="slide-fade" mode="out-in">
            <div v-show="visible" id="viewer" @click="visible = !visible"></div>
        </transition>
    </b-container>
</template>

<script>

import { BContainer, BCard, BMedia, BMediaAside, BMediaBody, BBadge, BButton, BIcon, BIconTrash, BIconFilePerson, BButtonGroup, BIconCloudDownload, BIconCrop, BIconPlusCircle } from 'bootstrap-vue';
import { models } from 'feathers-vuex';
import moment from 'moment';
import conf from '../../src/config/config';
import ConversionService  from '../services/ConversionService';
import Log from 'loglevel';
import FileSaver from 'file-saver';
import Api from '@/services/Api';
export default {
    components: {
        BContainer,
        BCard,
        BMedia,
        BMediaAside,
        BMediaBody,
        BBadge,
        BButton,
        BIcon,
        BButtonGroup,
        // eslint-disable-next-line vue/no-unused-components
        BIconTrash, BIconFilePerson, BIconCloudDownload, BIconCrop, BIconPlusCircle
    },
    name: 'Composition',
    data() {
        return {
            composition: null,
            editorUrl: null,
            products: [],
            thicknesses: [],
            visible : false,
            importData: false,
            language: 'fr'
        }
    },

    async mounted() {
        this.jwt_token = window.localStorage.getItem('feathers-jwt');
        this.protocol = window.location.protocol;
        moment.defaultFormat = "DD/MM/YYYY HH:mm";
        moment.locale('fr');
        this.language = navigator.language.substr(0,2).toLowerCase();
        await this.refreshProducts();
        await this.refreshThicknesses();
        console.log(this.$route.params.compositionId);
        this.editorUrl = conf.editor_url;
        this.composition = await models.api.Composition.get(this.$route.params.compositionId);
        this.afterLoad(this.composition);
        if(this.composition.importId){
            const importDataResponse = await Api().get(
                'dxf-imports/'+this.composition.importId,
                {
                    headers: {
                        'Authorization': `Bearer ${window.localStorage.getItem('feathers-jwt')}`,
                        'Accept': 'application/json',
                    },
                }
            );
            this.importData = importDataResponse.data;
        }
    },

    methods: {
        async refreshProducts() {
            let blockSize = 20;
            let response = await models.api.Product.find({query: {$limit: blockSize}});
            this.products = response.data;
            let steps = response.total / blockSize;

            for (let i = 1; i < steps; i++) {
                response = await models.api.Product.find({query: {$limit: blockSize, $skip: i * blockSize}});
                this.products = this.products.concat(response.data);
            }
            this.products.sort((a, b) => a.name[this.language].localeCompare(b.name[this.language]));
        },

        async refreshThicknesses() {
            let blockSize = 50;
            let response = await models.api.Thickness.find({query: {$limit: blockSize}});
            this.thicknesses = response.data;
            let steps = response.total / blockSize;

            for (let i = 1; i < steps; i++) {
                response = await models.api.Thickness.find({query: {$limit: blockSize, $skip: i * blockSize}});
                this.thicknesses = this.thicknesses.concat(response.data);
            }
            this.thicknesses.sort((a, b) => a.thickness - b.thickness);
        },

        afterLoad(composition) {
            composition.thickness = this.thicknesses.find(t => t.psid == composition.thicknessPsid);
            composition.product = this.products.find(p => p.psid == composition.productPsid);

            composition.viewbox = composition.viewboxdata == null
                ? "0 0 1000 1000"
                : (parseInt(composition.viewboxdata.x) - 10) + " " + (parseInt(composition.viewboxdata.y) - 10) + " " + (parseInt(composition.viewboxdata.width) + parseInt(composition.viewboxdata.x) + 20) + " " + (parseInt(composition.viewboxdata.height) + parseInt(composition.viewboxdata.y) + 20)

            composition.dimensions = composition.viewboxdata == null ? "" : parseInt(composition.viewboxdata.width) + " x " + parseInt(composition.viewboxdata.height);

            composition.updatedAtFromNow = composition.updatedAt == null ? "" : moment(composition.updatedAt).fromNow();
            composition.updatedAtLabel = composition.updatedAt == null ? "" : moment(composition.updatedAt).format('L LT');
            composition.createdAtFromNow = composition.createdAt == null ? "" : moment(composition.createdAt).fromNow();
            composition.createdAtLabel = composition.createdAt == null ? "" : moment(composition.createdAt).format('L LT');

            if (composition.svg) {
                console.log('!svg');
                composition.svgPart = Object.values(composition.svg).join('\n');
                composition.viewbox = (composition.viewboxdata.x - 10) + ' '
                    + (composition.viewboxdata.y - 10) + ' '
                    + (composition.viewboxdata.width + 20) + ' '
                    + (composition.viewboxdata.height + 20);
            }
        },

        async archive(composition) {

            if(confirm(this.$t('compositions.confirmarchive'))) {
                composition.archived = true;
                await composition.save();
                await this.refreshCompositions();
            }
        },

        async changeCustomerPsid(composition) {
            var customerPsid = prompt(this.$t('compositions.changecustomerprompt'), composition.originalCustomerPsid != composition.customerPsid ? composition.originalCustomerPsid : composition.customerPsid);
            if (customerPsid != null && customerPsid.length > 0) {
                composition.customerPsid = customerPsid;
                await composition.save();
                await this.refreshCompositions();
            }
        },

        async exportToDxf(pieceId,compositionId) {
            let dxfData = await ConversionService.exportToDxf(pieceId,compositionId);
            if (dxfData == null) {
                Log.warn("Donnees DXF vides apres conversion");
                return;
            }
            var blob = new Blob([dxfData], {type: "image/vnd.dxf;charset=utf-8"});
            FileSaver.saveAs(blob, compositionId+pieceId+".dxf");
        },

        async exportOrigineDxf(){
            const downloadDxfResponse = await Api().get(
                'dxf-imports/' + this.composition.importId,
                {
                    headers: {
                        'Authorization': `Bearer ${window.localStorage.getItem('feathers-jwt')}`,
                        'Content-Type': 'image/vnd.dxf', 
                        'Accept': 'image/vnd.dxf', 
                    }
                }
            );
            var blob = new Blob([downloadDxfResponse.data], {type: "image/vnd.dxf;charset=utf-8"});
            FileSaver.saveAs(blob, this.composition._id+".dxf");
        },

        async viewer(){
            document.querySelector('.svg-container').innerHTML;
            document.querySelector("#viewer").innerHTML = document.querySelector('.svg-container').innerHTML;
        },
    }
}
</script>

<style lang="scss" scoped>
    /* The sidebar menu */
    .card {
        flex: 1 0 20%;
        margin: 0.5em; 
    }

    .thumbnail {
        width: 14em;
        height: 8em;
        path {
            vector-effect: non-scaling-stroke;
        }
    }

    @import '../assets/scss/_variables.scss';

    .price {
        white-space: nowrap;
        font-size: 1.1rem;
    }

    .qty {
    border-radius: 0 10px 0 10px;
    }

    .bg-jaune {
        background: $jaune;
    }

    .slide-fade-enter-active {
        transition: all .3s ease;
    }
    .slide-fade-leave-active {
        transition: all .3s ease;
    }
    .slide-fade-enter, .slide-fade-leave-to {
        transform: translateY(-10px);
        opacity: 0;
    }

    .card-header {
        display: flex;
    }

    .justify-content-evenly{
        justify-content: space-evenly;
    }
    .m-auto{
        margin: auto;
    }

    #viewer{
        position: absolute;
        top: 0;
        bottom: 0;
        left: 15rem;
        right: 0;
        background-color: white;
        cursor: pointer;
    }

    .svg-container{
        cursor: pointer;
    }

    .importData{
        max-width: 50%;
        min-width: 50%;
        text-align: center;
    }
</style>
<style>
    .svg-container svg{
        width: 100%;
        height: 100%;
    }
    #viewer svg{
        width: 100%;
        height: 100%;
    }
</style>
